import type { ReactNode } from 'react';
import { CircleAlert, Cpu } from 'lucide-react';
import { Banner, Card, Fact, Facts } from '@/components/ui';
import type { SiteRuntimeView } from '@/types/api';

/**
 * What the site runs with (P9, S4, S5). A site published before these existed
 * says so, and says how to catch up: its uploads stop at the image's 2 MB and
 * its mail goes nowhere until then.
 */
export function RuntimeCard({ runtime }: { readonly runtime: SiteRuntimeView }): ReactNode {
  return (
    <Card title="Среда WordPress" icon={Cpu}>
      {!runtime.current ? (
        <Banner tone="warning" icon={CircleAlert}>
          Устаревшая конфигурация: загрузка файлов до 2 МБ, почта отключена. Выполните «Обновить WordPress/PHP» с той же версией
          шаблона.
        </Banner>
      ) : null}
      <Facts>
        <Fact label="Версия конфигурации">
          <span className="mono">v{runtime.specificationVersion}</span>
        </Fact>
        <Fact label="Загрузка файлов">
          {runtime.php ? `до ${runtime.php.uploadMaxMb} МБ (запрос до ${runtime.php.postMaxMb} МБ)` : 'до 2 МБ'}
        </Fact>
        <Fact label="Память PHP">
          {runtime.php ? `${runtime.php.memoryLimitMb} МБ · ${runtime.php.maxExecutionSeconds} с на запрос` : 'по умолчанию'}
        </Fact>
        <Fact label="Почта">{runtime.mail ? 'SMTP панели' : <span className="faint">не настроена</span>}</Fact>
        <Fact label="Планировщик">
          {runtime.systemCron ? 'системный, каждые 5 минут' : runtime.current ? 'выключен (тестовая копия)' : 'при посещениях'}
        </Fact>
        <Fact label="Ядро WordPress">{runtime.current ? 'из образа шаблона' : 'установленное при создании'}</Fact>
      </Facts>
    </Card>
  );
}
